import '../css/app.css';
import Alpine from '@alpinejs/csp';

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.data('navigationData', () => ({
    nav: document.getElementById('navigation'),
    isOpaque: false,
    showDropdown: false,
    scrollTop: 0,
    scrollBottom: document.documentElement.scrollHeight.valueOf(),
    notTop() {
      return this.scrollTop >= 16;
    },
    nearFooter() {
      return this.scrollBottom <= 693;
    },
    onScroll(opaqueContent) {
      this.scrollTop = document.documentElement.scrollTop.valueOf();
      this.scrollBottom = (document.documentElement.scrollHeight.valueOf() - this.scrollTop);
      this.setIsOpaque(opaqueContent);
    },
    onSearch() {
      //alert("Searching...");
    },
    setIsOpaque(opaqueContent) {
      this.isOpaque = opaqueContent || this.showDropdown || this.notTop();
    }
  })),
  Alpine.data('cookieBanner', () => ({
    showCookieBanner: false,
    showManagePreferences: false,
    essentialCookies: true,
    googleMapsConsent: false,
    scrollTop: 0,
    scrollBottom: document.documentElement.scrollHeight.valueOf(),
    saving: false,
    setShowCookieBanner(input) {
      this.showCookieBanner = input;
    },
    setShowManagePreferences(input) {
      this.showManagePreferences = input;

      this.$nextTick(() => {
        document.querySelector(
          'input[name="google_maps_consent"]'
        ).checked = this.googleMapsConsentGiven();
      });
    },
    nearFooter() {
      return this.scrollBottom <= 1590;
    },
    showUpdatePreferencesTab() {
      return !this.showCookieBanner && !this.nearFooter();
    },
    openManagePreferences() {
      this.setShowManagePreferences(true);
      this.setShowCookieBanner(true);
    },
    getGoogleMapsPreference() {
      if (!localStorage.getItem('google_maps_cookie_consent')) {
        return 'undecided';
      }

      return localStorage.getItem('google_maps_cookie_consent');
    },
    setGoogleMapsPreference(input) {
      if (input === true) {
        localStorage.setItem('google_maps_cookie_consent', "yes");

        location.reload();
      } else {
        localStorage.setItem('google_maps_cookie_consent', "no");
      }
    },
    googleMapsConsentGiven() {
      return this.getGoogleMapsPreference() === "yes";
    },
    rejectAll() {
      this.setGoogleMapsPreference(false);
      this.setShowCookieBanner(false);
    },
    acceptAll() {
      this.setGoogleMapsPreference(true);
      this.setShowCookieBanner(false);
    },
    async submit(){
      this.saving = true
      try {
        this.setGoogleMapsPreference(this.googleMapsConsent)
      } catch(e) {
        console.log(e)
      } finally {
        this.saving = false
        this.setShowCookieBanner(false);
      }
    },
    cookieOnScroll() {
      this.scrollTop = document.documentElement.scrollTop.valueOf();
      this.scrollBottom = (document.documentElement.scrollHeight.valueOf() - this.scrollTop);
    },
    init() {
      this.showCookieBanner = this.getGoogleMapsPreference() === 'undecided';
    }
  }))
  Alpine.data('heroSecondary', () => ({
    isLong: false,
    setIsLong() {
      let h1Length = document.querySelector('#hero-heading')?.innerText?.length;

      let totalheadingLength = document.querySelector(
        '#hero-subheading'
      )?.innerText?.length + h1Length;

      this.isLong = (h1Length > 32) || (totalheadingLength > 40);
    },
  })),
  Alpine.data('carousel', () => ({
    currentSlide: 0,
    visibleSlides: 1,
    slidePercentage: 100,
    next() {
      if (this.currentSlide < this.slides.length - this.visibleSlides) {
        this.currentSlide += 1;
      }
    },
    prev() {
      if (this.currentSlide > 0) {
        this.currentSlide -= 1;
      }
    },
    goTo(index) {
      if (index <= this.slides.length - this.visibleSlides) {
        this.currentSlide = index;
      } else {
        this.currentSlide = this.slides.length - this.visibleSlides;
      }
    },
    handleImageError(slide) {
      slide.image = 'assets/logos/red_medium.png';
    }
  })),
  Alpine.data('faqs', () => ({
    openedIndex: 1,
    openQuestion(currentIndex) {
      return this.openedIndex === currentIndex ?
        this.openedIndex = -1 : this.openedIndex = currentIndex
    },
    showAnswer(currentIndex) {
      return this.openedIndex === currentIndex
    }
  }))
});

Alpine.start();
